import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    on: translate({ id: 'global.on' }),
    off: translate({ id: 'global.off' }),
    regions: translate({ id: 'global.regions' }),
    disabledInRegionSection: translate({ id: 'globalStyles.regions.disabledInRegion' }),
    noRegions: translate({ id: 'globalStyles.regions.noRegions' }),
  }))

  return api
}
